/**
 * This file contains the configuration for the API.
 */

const {REACT_APP_API_DOMAIN} = process.env;

const baseDomain: string = REACT_APP_API_DOMAIN || "localhost";
export const baseUrl = `https://${baseDomain}/api`;